import { Box, Typography } from "@mui/material";

export default function NotFound(params) {

    return <Box sx={{ display: 'flex', height: "100%", flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <Typography sx={{ color: 'red' }} variant="h5">404</Typography>
        <Typography sx={{ color: 'red' }} variant='h6'>Page Not Found</Typography>
    </Box>
}
